import React, { FC, ReactNode } from "react";
import { Box } from "@mui/material";

type Props = {
	open: boolean;
	onClose?: () => void;
	children: ReactNode;
};

export const DrawerContainer: FC<Props> = ({ open, onClose, children }) => {
	return (
		<Box
			sx={{
				zIndex: 5,
				opacity: open ? 1 : 0,
				// Closed content stays mounted for the slide-out animation, so without
				// this it remains focusable and in the tab order while invisible (WCAG 1.3.2).
				// Transitioning "all" flips visibility to hidden only once the fade/slide
				// finishes closing, and to visible instantly on open, per the CSS spec.
				visibility: open ? "visible" : "hidden",
				pointerEvents: open ? "auto" : "none",
				position: "fixed",
				left: 0,
				right: 0,
				top: 0,
				bottom: 0,
				background: open ? "#00000040" : "#00000000",
				transition: "all 200ms ease-out",
			}}
			onClick={(e) => {
				if (e.target === e.currentTarget) {
					onClose?.();
				}
			}}
		>
			<Box
				sx={{
					position: "absolute",
					top: 0,
					right: 0,
					bottom: 0,
					background: "white",
					transition: "all 200ms ease-in-out",
					transform: open ? "translateX(0)" : "translateX(500px)",
				}}
			>
				{children}
			</Box>
		</Box>
	);
};
